<template>
  <div class="ximi-mall-container">
    <!-- <BackgroundEffect /> -->
    <!-- <MallHeader /> -->
    <MallNavigation />
    <HeroSection />
    
    <!-- 楼层渲染 -->
    <div class="container">
      <ProductFloor v-for="(floor, idx) in floors" :key="idx" :floor="floor" :index="idx" />
    </div>
    
    <PartnersSection />
    <!-- <MallFooter /> -->

    <!-- ================= 右侧固定客服工具栏 ================= -->
    <div class="fixed-contact-sidebar">
      
      <!-- 微信项 -->
      <!-- <div class="sidebar-item wechat-trigger">
        <div class="item-inner">
          <svg class="icon" viewBox="0 0 1024 1024" width="24" height="24">
            <path d="M685.3 437.4c8.9 0 17.6 0.8 26 2.3-2.3-132.1-121.7-236.8-267.3-236.8-158.5 0-287.1 110.8-287.1 247.4 0 79.1 43.1 149.2 110.8 195.9l-28.2 84.6 97.4-52c34.7 9.6 71.3 14.9 109.8 14.9 8.2 0 16.3-0.3 24.3-0.9-6.3-15.1-9.8-31.7-9.8-49.1 0-113.8 100.3-206.3 224.1-206.3z" fill="currentColor"></path>
            <path d="M885 640.4c0-104.7-86.1-189.5-192.3-189.5-106.3 0-192.3 84.8-192.3 189.5s86.1 189.5 192.3 189.5c26.3 0 51.3-5.2 74-14.7l64.1 34.2-18.6-55.7c44.8-34.1 72.8-89.9 72.8-153.3z" fill="currentColor"></path>
          </svg>
          <span class="text">微信</span>
        </div>
        <div class="popover-panel">
          <div class="popover-content">
            <img src="../../../assets/wechart.jpg" style="width:150px" alt="微信公众号" />
            <p>客服微信</p>
          </div>
        </div>
      </div>

      <div class="sidebar-item qq-trigger">
        <div class="item-inner">
          <svg class="icon" viewBox="0 0 1024 1024" width="22" height="22">
            <path d="M824.8 613.2c-16-18.6-56.2-71.2-56.2-71.2V376c0-151.2-120-274.2-266.6-274.2-143.6 0-261 118.4-266.4 265.4l-0.2 10.6c0 1.2 0 1.2 0 1.8v161.4s-39.6 51.6-55.8 71.2c-39 47.4-40.8 61.2-40.8 82.8 0 14.4 3.6 22.8 12.6 28.8 12 7.8 31.8 12 55.2 13.2 13.8 19.8 45.6 51 90.6 51 21 0 44.4-11.4 61.8-24.6 21.6 4.8 45 7.8 70.8 7.8 24 0 46.2-2.4 66-7.2 16.8 12.6 38.4 24 59.4 24 45 0 76.8-31.2 90.6-51 23.4-1.2 43.2-5.4 55.2-13.2 9-6 12.6-14.4 12.6-28.8 0-21.6-1.8-35.4-40.8-82.8z" fill="currentColor"></path>
          </svg>
          <span class="text">QQ</span>
        </div>
        <div class="popover-panel qq-panel">
          <div class="popover-content">
            <div class="popover-title">联系客服</div>
            <div class="qq-grid">
              <div class="qq-account-card">
                <span class="label">客服-思思</span>
                <span class="val">3891863041</span>
              </div>
              <div class="qq-account-card">
                <span class="label">客服-思谊</span>
                <span class="val">3984132181</span>
              </div>
              <div class="qq-account-card">
                <span class="label">客服-娜娜</span>
                <span class="val">2559726439</span>
              </div>
              <div class="qq-account-card">
                <span class="label">客服-婷婷</span>
                <span class="val">649488660</span>
              </div>
            </div>
            <p class="tip">工作时间 9点-下午五点半</p>
          </div>
        </div>
      </div> -->

    </div>

    <!-- 回到顶部 -->
    <el-backtop :right="40" :bottom="40"></el-backtop>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { findCategoryPro } from "@/apis/api";
import MallNavigation from './components/MallNavigation.vue';
import HeroSection from './components/HeroSection.vue';
import ProductFloor from './components/ProductFloor.vue';
import PartnersSection from './components/PartnersSection.vue';

const floors = ref([]);

const getFindCategoryPro = async () => {
  try {
    const res = await findCategoryPro();
    floors.value = res.data;
  } catch (err) {
    console.error("获取数据失败:", err);
  }
};

onMounted(() => {
  getFindCategoryPro();
});
</script>

<style>
/* 变量定义 */
:root {
  --bg-color: #f0f2f5;
  --tech-blue: #0066cc;
  --text-main: #0f172a;
  --text-sub: #64748b;
  --glass-bg: rgba(255, 255, 255, 0.9);
  --glass-border: none;
  --glass-shadow: 0 8px 32px rgba(0, 50, 150, 0.1);
}

body {
  background-color: var(--bg-color);
  margin: 0;
  font-family: 'PingFang SC', sans-serif;
}

.container {
  width: 95%;
  max-width: 1440px;
  margin: 0 auto;
}

/* ================= 侧边栏基础样式 ================= */
.fixed-contact-sidebar {
  position: fixed;
  right: 40px;
  bottom: 115px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sidebar-item {
  width: 56px;
  height: 56px;
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  border: var(--glass-border);
  border-radius: 12px;
  box-shadow: var(--glass-shadow);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  position: relative;
  color: var(--text-main);
}

.sidebar-item:hover {
  background: var(--tech-blue);
  color: #fff;
  transform: translateY(-3px);
}

.item-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.item-inner .text {
  font-size: 11px;
  margin-top: 2px;
}

.popover-panel {
  position: absolute;
  right: 75px;
  top: 50%;
  transform: translateY(-50%) scale(0.9);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  pointer-events: none;
}

.popover-content {
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.12);
  border: 1px solid #eee;
  position: relative;
}

/* 装饰小三角 */
.popover-content::after {
  content: "";
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: #fff;
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
}

/* 悬浮显示逻辑 */
.sidebar-item:hover .popover-panel {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) scale(1);
  pointer-events: auto;
}

/* ================= 微信专用样式 ================= */
.popover-content img {
  width: 130px;
  height: 130px;
  display: block;
  border-radius: 4px;
}

.popover-content p {
  margin: 10px 0 0;
  color: #666;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
}

/* ================= QQ 专用样式 (4账号网格) ================= */
.qq-panel {
  width: 280px; /* 较宽以容纳两列 */
}

.popover-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  padding-left: 4px;
  border-left: 3px solid var(--tech-blue);
}

.qq-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.qq-account-card {
  background: #f8fafc;
  padding: 8px 10px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  transition: background 0.2s;
}

.qq-account-card:hover {
  background: #eff6ff;
}

.qq-account-card .label {
  font-size: 11px;
  color: var(--text-sub);
  margin-bottom: 2px;
}

.qq-account-card .val {
  font-size: 13px;
  color: var(--tech-blue);
  font-weight: 600;
  font-family: 'Monaco', monospace;
}

.qq-panel .tip {
  margin-top: 12px;
  font-size: 11px;
  color: #94a3b8;
  text-align: center;
}

/* ================= 回到顶部样式优化 ================= */
.el-backtop {
  background-color: var(--glass-bg) !important;
  color: var(--text-main) !important;
  border: var(--glass-border) !important;
  box-shadow: var(--glass-shadow) !important;
  width: 56px !important;
  height: 56px !important;
  border-radius: 12px !important;
}

.el-backtop:hover {
  background-color: var(--tech-blue) !important;
  color: #fff !important;
}
</style>